<template>
  <div ref="modalPhieuKhamChuyenKhoa" class="modal fade" id="modalPhieuKhamChuyenKhoa" tabindex="-1" role="dialog"
    aria-labelledby="modalPhieuXacNhanDieuTriLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content" v-loading="loading">
        <div class="d-flex justify-content-between p-3 mt-3">
          <div class="fs-24 fw-700 txt-grey-900 text-center w-100">
            <span>PHIẾU KHÁM CHUYÊN KHOA</span>
          </div>
          <button type="button" id="closeModal" class="close bg-white border-0" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" class="fs-30 fw-500">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="block mt-4 fs-18">
            <div class="col-6">
              <div class="flex">
                <div class="fs-18">Họ tên người bệnh:</div>
                <div class="fs-18 font-bold ml-1">
                  {{ person.name }}
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="flex">
                <div class="fs-18">
                  Tuổi:
                  <span class="fs-18 font-bold ml-1">{{
                    getAge()
                  }}</span>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="flex">
                <div class="fs-18">Giới tính:</div>
                <div class="fs-18 font-bold ml-1">
                  {{ getGender() }}
                </div>
              </div>
            </div>
            <div class="fs-18 mt-2 mb-2">Địa chỉ: {{ addressPerson }}</div>

            <div class="col-6">
              <div class="fs-18">
                Khoa: {{ $globalClinic ? $globalClinic.name : "" }}
              </div>
            </div>

            <div class="col-3">
              <div class="flex">
                <div class="fs-18">Buồng:</div>
                <div class="fs-18 ml-1" v-show="person.admission_room">
                  {{ person.admission_room }}
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="flex">
                <div class="fs-18">Giường:</div>
                <div class="fs-18 ml-1" v-show="person.admission_bed">
                  {{ person.admission_bed }}
                </div>
              </div>
            </div>
            <div class="fs-18 mt-2 mb-4">Chẩn đoán: {{ getTreatDeptMain() }}</div>
          </div>
          <div class="mb-3">
            <div class="fs-14 fw-700 w-44">Kính gửi:</div>
            <input v-model="form.salutation" class="form--input h-10" />
          </div>
          <div class="mb-3">
            <div class="fs-14 fw-700 w-44">Yêu cầu khám chuyên khoa:</div>
            <EditorInput id="treatment-xndt" :prop_text="form.requested_consultation"
              @onChangeContent="(content) => form.requested_consultation = content" />
          </div>
          <div class="mb-3">
            <div class="fs-14 fw-700 w-44">Kết quả khám chuyên khoa:</div>
            <EditorInput id="treatment-xndt" :prop_text="form.result_consultation"
              @onChangeContent="(content) => form.result_consultation = content" />
          </div>
        </div>
        <div class="modal-footer">
          <button v-loading="loading" @click="onSubmit" type="button" class="btn bg-pri text-white">Lưu phiếu</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditorInput from '@/components/EditorInput.vue'
import { mapState } from 'vuex'
import { mixinGetPersonInfo } from '@/utils/mixinGetPersonInfo'
import appUtils from '@/utils/appUtils'

export default {
  name: 'ModalPhieuKhamChuyenKhoa',
  components: { EditorInput },
  props: ['type', 'specialistConsultationData'],
  mixins: [mixinGetPersonInfo],
  data () {
    return {
      form: {
        salutation: '',
        requested_consultation: '',
        result_consultation: ''
      },
      defaultForm: {
        salutation: '',
        requested_consultation: '',
        result_consultation: ''
      },
      loading: false
    }
  },
  watch: {
    '$route.query.vId': {
      handler: function (vId) {
        if (!vId) return
        this.getPersonsDiseases()
      },
      deep: true,
      immediate: true
    },
    specialistConsultationData () {
      this.handleMapUpdateData()
    },
    medicalRecordMain () {
      if (this.type === 'create') {
        let self = this
        self.form.diagnostic = self.medicalRecordMain.treat_dept_main_name
        self.form.treatment = self.medicalRecordMain.treatment_direction
      }
    }
  },
  mounted () {
    this.handleMapUpdateData()
    if (this.type === 'create') {
      let self = this
      const currentDoctorId = self.$user.doctor.id
      self.form.doctor_id = currentDoctorId
      self.form.diagnostic = self.medicalRecordMain.treat_dept_main_name
      self.form.treatment = self.medicalRecordMain.treatment_direction
    }
  },
  computed: {
    ...mapState({
      emrData: state => state.emrData,
      person: state => state.person
    }),
    ...mapState({
      medicalRecordMain: state => state.medicalRecordMain
    }),
    addressPerson () {
      return this.getAddress(this.medicalRecordMain || this.person)
    }
  },

  methods: {
    getGender () {
      return appUtils.getGender(this.person.gender)
    },
    getAge () {
      return (
        this.person.birthday &&
        (window.moment().diff(this.person.birthday, 'years', false)
          ? window.moment().diff(this.person.birthday, 'years', false)
          : '')
      )
    },
    getTreatDeptMain () {
      let result = ''
      if (
        this.medicalRecordMain &&
        this.medicalRecordMain.treat_dept_main_code
      ) {
        result += this.medicalRecordMain.treat_dept_main_code
      }
      if (
        this.medicalRecordMain &&
        this.medicalRecordMain.treat_dept_main_name
      ) {
        result = result + '-' + this.medicalRecordMain.treat_dept_main_name
      }
      return result
    },
    handleMapUpdateData () {
      if (this.type === 'update' && this.specialistConsultationData) {
        this.form = {
          salutation: this.specialistConsultationData.salutation,
          requested_consultation: this.specialistConsultationData.requested_consultation,
          result_consultation: this.specialistConsultationData.result_consultation
        }
      }
    },
    onSubmit () {
      if (this.type === 'create') {
        this.$emit('onCreate', this.form)
        this.form = { ...this.defaultForm, doctor_id: self.$user.doctor.id }
        window.$('button#closeModal').trigger('click')
      } else {
        this.updateSpecialistConsultation()
      }
    },
    async updateSpecialistConsultation () {
      this.loading = true
      const id = this.$route.query.vId
      const params = {
        medical_record_id: Number(this.$route.params.id),
        person_id: this.person.id,
        workspace_id: this.$globalClinic.id,
        org_id: this.$globalClinic ? this.$globalClinic.organization.id : '',
        requested_consultation: this.form.requested_consultation,
        result_consultation: this.form.result_consultation,
        salutation: this.form.salutation
      }

      await this.$rf
        .getRequest('DoctorRequest')
        .updateSpecialistConsultation(id, params)
        .then(r => {
          this.$emit('onUpdate')
          window.$('button#closeModal').trigger('click')
          this.$toast.open({
            message: 'Chỉnh sửa thành công',
            type: 'success'
          })
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    openModal (show) {
      window.$('#modalPhieuKhamChuyenKhoa').modal(show ? 'show' : 'hide')
      let self = this
      self.$nextTick(function () {
        this.form = { ...this.defaultForm, doctor_id: self.$user.doctor.id }
      })
    }
  }
}
</script>
<style lang="scss">
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reverse-ellipsis {
  /* Your move. */
  text-overflow: clip;
  position: relative;
  background-color: #fff;
}

.reverse-ellipsis:before {
  content: '\02026';
  position: absolute;
  z-index: 1;
  left: -2em;
  background-color: inherit;
  padding-left: 1em;
  margin-left: 0.5em;
}

.reverse-ellipsis span {
  min-width: 100%;
  position: relative;
  display: inline-block;
  float: right;
  overflow: visible;
  background-color: inherit;
  text-indent: 0.5em;
}

.reverse-ellipsis span:before {
  content: '';
  position: absolute;
  display: inline-block;
  width: 1em;
  height: 1em;
  background-color: inherit;
  z-index: 200;
  left: -0.5em;
}
</style>
